'use strict';

var CriteriaRuleDirective = function CriteriaRuleDirective() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: require('../templates/criteria-rule.html'),
    controller: 'CriteriaRuleController',
    scope: {
      searchCriteria: '=',
      criteriaUpdated: '&',
      searchContext: '='
    },
    link: function link($scope) {
      if (!$scope.selected.isReadOnly) {
        $scope.$on('search-criteria-category-changed', $scope.updateCategories);
        $scope.$on('search-criteria-level-changed', $scope.updateLevels);
      }
    }
  };
};
CriteriaRuleDirective.$inject = [];
module.exports = CriteriaRuleDirective;